const validarCuit = cuit => {
  if (cuit) {
    cuit = cuit.replace(/-/g, '');

    if (cuit.length != 11) {
      return false;
    }

    const digitos = cuit.split('');
    const multiplicadores = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let valor1 = 0;

    for (let i = 0; i <= 9; i++) {
      valor1 += Number(parseInt(digitos[i]) * multiplicadores[i]);
    }

    const valor2 = valor1 % 11;
    const valor3 = 11 - valor2;

    let verificador = 0;
    if (valor3 === 11) {
      verificador = 0;
    } else {
      verificador = valor3;
    }
    return verificador === parseInt(digitos[10]) && verificador !== 10;
  }
};

export default validarCuit;
